// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__K-KUt","checkboxCol":"Table_checkboxCol__2UzNQ","emailCol":"Table_emailCol__1gsDz","actionCol":"Table_actionCol__Z1zgY"};